import { Box, Image, Link } from "@chakra-ui/react";
import Head from "next/head";
import { useRouter } from "next/router";
import { ReactElement } from "react";

import { BANNERS } from "src/const/banner";
import { S3_URL } from "src/const/s3Endpoint";
import type { NextPageWithLayout } from "src/pages/_app.page";
import { MomoChakraProvider } from "src/providers/MomoChakraProvider";

export type Query = {
  uid: string;
  size: keyof typeof BANNERS;
};

const Page: NextPageWithLayout = () => {
  const router = useRouter();
  const { uid, size } = router.query as Query;

  const handleContextMenu = (event: React.MouseEvent) => {
    event.preventDefault();
  };

  return (
    <Box onContextMenu={handleContextMenu}>
      {!!uid && (
        <Link href={`/banner/${uid}`} isExternal>
          {size in BANNERS && (
            <Image
              src={`${S3_URL}/momo/clinic/${BANNERS[size].fileName}`}
              w={BANNERS[size].width}
            />
          )}
        </Link>
      )}
    </Box>
  );
};

Page.getLayout = (page: ReactElement) => (
  <>
    <Head>
      <title>クロンスマートパス</title>
    </Head>

    <MomoChakraProvider>{page}</MomoChakraProvider>
  </>
);

export default Page;
